import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DataTable from 'react-data-table-component';

export default class ExploreWarehouseReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            id_to_remove: null,
            phrase: '',
            ids: [],
            filters: {},
            selectedWarehouse: [],
            selectedStuff: [],
            selectedCustomer: [],
            searchColumn: 'date',
            filterLevels: [0, 0, 0],
            filterLevel: -1,
            clearSelectedRows: false,
            phrase1: '',
            phrase2: '',
            phrase3: '',
            phrase4: '',
            phrase5: '',

        };
    }

    componentDidMount() {
        this.refreshData(null,'explore/warehouse');
    }


    showRemittance(_record) {
        var code = _record.fullCode;
        var level = 1;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;

            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }
            if (checkSide == 1) {
            }
            if (checkSide == -1) {
                if (this.state.filterLevels[checkerLevel] == 2) {
                    this.state.selectedStuff.forEach(f => {
                        if (f.fullCode.toString().substr(0, 2) == code) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 3) {
                    this.state.selectedCustomer.forEach(f => {
                        if (f.fullCode.toString().substr(0, 2) == code) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase1)) {
            if (!_record.title.includes(this.state.phrase1) && !_record.fullCode.toString().includes(this.state.phrase1) &&
                !_record.remain.toString().includes(this.state.phrase1) &&
                !_record.in.toString().includes(this.state.phrase1) && !_record.out.toString().includes(this.state.phrase1)) v = false;
        }
        return v;
    }
    showStuf(_record) {
        var code = _record.fullCode;
        var level = 2;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;
            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }
            if (checkSide == 1) {
                if (this.state.filterLevels[checkerLevel] == 1) {
                    this.state.selectedWarehouse.forEach(f => {
                        if (code >= f.fullCode * 100 && code <= (f.fullCode * 100) + 99) v = true;
                    });
                }
            }
            if (checkSide == -1) {
                if (this.state.filterLevels[checkerLevel] == 3) {
                    this.state.selectedCustomer.forEach(f => {
                        if (f.fullCode.toString().substr(0, 4) == code) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase2)) {
            if (!_record.title.includes(this.state.phrase2) && !_record.fullCode.toString().includes(this.state.phrase2) &&
                !_record.remain.toString().includes(this.state.phrase2) &&
                !_record.in.toString().includes(this.state.phrase2) && !_record.out.toString().includes(this.state.phrase2)) v = false;
        }

        return v;
    }
    showCustomer(_record) {
        var code = _record.fullCode;
        var level = 3;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;

            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }

            if (checkSide == 1) {
                if (this.state.filterLevels[checkerLevel] == 2) {
                    this.state.selectedStuff.forEach(f => {
                        if (code >= f.fullCode * 100 && code <= (f.fullCode * 100) + 99) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 1) {
                    this.state.selectedWarehouse.forEach(f => {
                        if (code >= f.fullCode * 10000 && code <= (f.fullCode * 10000) + 9999) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase3)) {
            if (!_record.title.includes(this.state.phrase3) && !_record.fullCode.toString().includes(this.state.phrase3) &&
                !_record.remain.toString().includes(this.state.phrase3) &&
                !_record.in.toString().includes(this.state.phrase3) && !_record.out.toString().includes(this.state.phrase3)) v = false;
        }

        return v;
    }

    getRemittanceRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 7 && this.showRemittance(record)) t.push(record);
        });
        return t;
    }
    getStuffRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 6 && this.showStuf(record)) t.push(record);
        });
        return t;
    }
    getCustomerRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 5 && this.showCustomer(record)) t.push(record);
        });
        return t;
    }

    setFilterItem(selectedRows, level) {
        var preChecked = false;
        for (var i = 0; i < this.state.filterLevel; i++) {
            if (this.state.filterLevels[i] == level) {
                this.state.filterLevel = i;
                preChecked = true;
            }
        }
        if (this.state.filterLevel == -1) this.state.filterLevel++;
        if (this.state.filterLevels[this.state.filterLevel] != level) {
            if (this.state.filterLevels[this.state.filterLevel] == 0) this.state.filterLevels[this.state.filterLevel] = level;
            else {
                if (!preChecked) this.state.filterLevel++;
                this.state.filterLevels[this.state.filterLevel] = level;
            }
        }

        if (level == 1) {
            this.state.selectedWarehouse = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedWarehouse.push(r));
            this.setState({ selectedWarehouse: this.state.selectedWarehouse });
        }
        if (level == 2) {
            this.state.selectedStuff = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedStuff.push(r));
            this.setState({ selectedStuff: this.state.selectedStuff });
        }
        if (level == 3) {
            this.state.selectedCustomer = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedCustomer.push(r));
            this.setState({ selectedCustomer: this.state.selectedCustomer });
        }
    }
    removeFilters() {
        this.state.selectedWarehouse = [];
        this.state.selectedStuff = [];
        this.state.selectedCustomer = [];

        this.setState({
            clearSelectedRows: !this.state.clearSelectedRows,
            filterLevel: -1,
            filterLevels: [0, 0, 0]
        })
    }
    renderFilters() {
        var filterLevels = this.state.filterLevels;
        var res = [];
        if (filterLevels[0] != 0) {
            var items = [];
            if (filterLevels[0] == 1) items = this.state.selectedWarehouse;
            if (filterLevels[0] == 2) items = this.state.selectedStuff;
            if (filterLevels[0] == 3) items = this.state.selectedCustomer;
            if (!this.isEmpty(items)) res.push(<span onClick={e => this.removeFilters()} className="hand badge rounded-pill bg-danger me-1">حذف فیلترها</span>);
            items.forEach(item => {
                if ((item.accountType == 7 && this.showRemittance(item)) || (item.accountType == 6 && this.showStuf(item)) ||
                    (item.accountType == 5 && this.showCustomer(item))) {
                    res.push(<span className="badge rounded-pill bg-info me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[1] != 0) {
            let items = [];
            if (filterLevels[1] == 1) items = this.state.selectedWarehouse;
            if (filterLevels[1] == 2) items = this.state.selectedStuff;
            if (filterLevels[1] == 3) items = this.state.selectedCustomer;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 7 && this.showRemittance(item)) || (item.accountType == 6 && this.showStuf(item)) ||
                    (item.accountType == 5 && this.showCustomer(item))) {
                    res.push(<span className="badge rounded-pill bg-primary me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[2] != 0) {
            let items = [];
            if (filterLevels[2] == 1) items = this.state.selectedWarehouse;
            if (filterLevels[2] == 2) items = this.state.selectedStuff;
            if (filterLevels[2] == 3) items = this.state.selectedCustomer;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 7 && this.showRemittance(item)) || (item.accountType == 6 && this.showStuf(item)) ||
                    (item.accountType == 5 && this.showCustomer(item))) {
                    res.push(<span className="badge rounded-pill bg-primary me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[3] != 0) {
            let items = [];
            if (filterLevels[3] == 1) items = this.state.selectedWarehouse;
            if (filterLevels[3] == 2) items = this.state.selectedStuff;
            if (filterLevels[3] == 3) items = this.state.selectedCustomer;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 7 && this.showRemittance(item)) || (item.accountType == 6 && this.showStuf(item)) ||
                    (item.accountType == 5 && this.showCustomer(item))) {
                    res.push(<span className="badge rounded-pill bg-primary me-1">{item.title}</span>);
                }
            });
        }

        return res;
    }

    handleRowClick = (id) => {
        window.location.href = `/remittance/edit/${id}`;
    };


    getFilteredRecords = () => {
        const { phrase5, searchColumn } = this.state;
        const records = this.state.data.remittanceTransactions;

        if (!phrase5) return records;

        return records.filter(record => {
            return record[searchColumn].toString().includes(phrase5);
        });
    };

    remittanceTypeConverter = (type) => {
        switch (type) {
            case 1:
                return 'حواله - فروش';
            case 2:
                return 'رسید - برگشت از فروش';
            case 3:
                return 'حواله - صادرات';
            case 4:
                return 'رسید - خرید';
            case 5:
                return 'حواله - برگشت از خرید';
            case 6:
                return 'رسید - واردات';
            default:
                return 'نامشخص';
        }
    };



    renderForm() {
        console.log(this.state.data.remittanceTransactions)
        return <div>
            <div className="card card-bordered card-preview">
                <div className="card-inner">
                    <div className="mb-2">{this.renderFilters()}</div>
                    <div className="fixed-tabs">
                        <ul className="nav nav-tabs mt-n3">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="tab" href="#remittance"><em className="icon ni ni-info"></em><span>انبار</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#stuff"><em className="icon ni ni-list-round"></em><span>کالا</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#customer"><em className="icon ni ni-wallet-alt"></em><span>مشتری</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#trx"><em className="icon ni ni-wallet-alt"></em><span>گردش کالا</span></a>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div className="tab-pane active" id="remittance">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={[
                                                            {
                                                                name: 'نام انبار',
                                                                selector: row => row.fullCode + " - " + row.title,
                                                                sortable: true,
                                                            },
                                                            {
                                                                name: 'ورودی',
                                                                selector: row => row.in,
                                                                format: row => row.in == null ? "" : row.in.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'خروجی',
                                                                selector: row => row.out,
                                                                format: row => row.out == null ? "" : row.out.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'مانده ',
                                                                selector: row => row.remain,
                                                                format: row => row.remain == null ? "" : row.remain.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },

                                                        ]}
                                                        data={this.getRemittanceRecords()}                                                                                                                
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 1)}
                                                        subHeader
                                                        subHeaderComponent={<div style={{ "display": "flex", "flex-direction": "column", "width": "100%" }}><input defaultValue={this.state.phrase1} onChange={e => this.setState({ phrase1: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} /></div>}
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="stuff">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={[
                                                            {
                                                                name: 'شرح کالا',
                                                                selector: row => row.fullCode + " - " + row.title,
                                                                sortable: true,
                                                            },
                                                            {
                                                                name: 'ورودی',
                                                                selector: row => row.in,
                                                                format: row => row.in == null ? "" : row.in.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'خروجی',
                                                                selector: row => row.out,
                                                                format: row => row.out == null ? "" : row.out.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'مانده ',
                                                                selector: row => row.remain,
                                                                format: row => row.remain == null ? "" : row.remain.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },

                                                        ]}
                                                        data={this.getStuffRecords()}                                                       
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 2)}
                                                        subHeader
                                                        subHeaderComponent={<div style={{ "display": "flex", "flex-direction": "column", "width": "100%" }}><input defaultValue={this.state.phrase2} onChange={e => this.setState({ phrase2: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} /></div>}
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="customer">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={[
                                                            {
                                                                name: 'طرف حساب',
                                                                selector: row => row.fullCode + " - " + row.title,
                                                                sortable: true,
                                                            },
                                                            {
                                                                name: 'ورودی',
                                                                selector: row => row.in,
                                                                format: row => row.in == null ? "" : row.in.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'خروجی ',
                                                                selector: row => row.out,
                                                                format: row => row.out == null ? "" : row.out.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },
                                                            {
                                                                name: 'مانده ',
                                                                selector: row => row.remain,
                                                                format: row => row.remain == null ? "" : row.remain.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                                                sortable: true,
                                                                center: true,
                                                                width: "160px"
                                                            },

                                                        ]}
                                                        data={this.getCustomerRecords()}
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 3)}
                                                        subHeader
                                                        subHeaderComponent={<div style={{ "display": "flex", "flex-direction": "column", "width": "100%" }}><input defaultValue={this.state.phrase3} onChange={e => this.setState({ phrase3: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} /></div>}
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="trx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner  p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable

                                                        columns={[
                                                            {
                                                                name: 'تاریخ',
                                                                selector: row => row.date,
                                                                sortable: true,
                                                                center: true,
                                                                width: "130px"
                                                            },
                                                            {
                                                                name: 'شرح',
                                                                selector: row => row.description,
                                                                sortable: true,
                                                            },
                                                            {
                                                                name: 'کالا',
                                                                selector: row => row.stuffName,
                                                                format: row => (
                                                                    <span style={{ fontSize: '12px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                        {row.stuffName}
                                                                    </span>
                                                                ),
                                                                sortable: true,
                                                                center: true,
                                                                width: "150px"
                                                            },
                                                            {
                                                                name: 'مشتری/تامین کننده',
                                                                selector: row => row.customerName
,
                                                                format: row => (
                                                                    <span style={{ fontSize: '12px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                                        {row.customerName}
                                                                    </span>
                                                                ),
                                                                sortable: true,
                                                                center: true,
                                                                width: "150px"
                                                            },
                                                            {
                                                                name: 'شماره رسید / حواله',
                                                                selector: row => row.number,
                                                                sortable: true,
                                                                center: true,
                                                                width: "150px",
                                                                cell: row => (
                                                                    <div className="btn btn-dark" onClick={() => this.handleRowClick(row.remittanceId)}>
                                                                        {row.number}
                                                                    </div>
                                                                ),

                                                            },
                                                            {
                                                                name: 'نوع',
                                                                selector: row => row.remittanceType,
                                                                format: row => {
                                                                    if (row.remittanceType === 2 || row.remittanceType === 4 || row.remittanceType === 6) {
                                                                        return(
                                                                            <span className="tb-status text-success">
                                                                                {this.remittanceTypeConverter(row.remittanceType)}
                                                                            </span>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <span className="tb-status text-info">
                                                                                {this.remittanceTypeConverter(row.remittanceType)}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                                sortable: true,
                                                                center: true,
                                                                width: "150px"
                                                            },
                                                            {
                                                                name: 'ورود (خروج)',
                                                                selector: row => (row.remittanceType === 2 || row.remittanceType === 4 || row.remittanceType === 6) ? row.amount : -row.amount,
                                                                format: row => {
                                                                    if (row.remittanceType === 2 || row.remittanceType === 4 || row.remittanceType === 6) {
                                                                        return row.amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                                                    } else {
                                                                        return (
                                                                            <span style={{ color: 'red' }}>
                                                                                ({(row.amount).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")})
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                                sortable: true,
                                                                center: true,
                                                                width: "150px"
                                                            },
                                                        ]}
                                                        data={this.getFilteredRecords()}
                                                        noDataComponent={<div className="mt-3">رکوردی برای نمایش وجودی ندارد</div>}
                                                        direction="rtl"
                                                        subHeader
                                                        subHeaderComponent={
                                                            <div className="card-title-group" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                                <div className="form-wrap me-2">
                                                                    <input
                                                                        defaultValue={this.state.phrase5}
                                                                        onChange={e => this.setState({ phrase5: e.target.value })}
                                                                        type="text"
                                                                        placeholder="جست و جو بر اساس"
                                                                        className="form-control"
                                                                        style={{ width: '150px', height: '40px', textAlign: 'center' }}
                                                                    />
                                                                </div>
                                                                <div className="form-wrap">
                                                                    <select
                                                                        onChange={e => this.setState({ searchColumn: e.target.value })}
                                                                        className="form-select form-select-lg "
                                                                        style={{ width: '150px', height: '40px', textAlign: 'center', fontSize: '0.8rem' }}
                                                                    >
                                                                        <option value="date">تاریخ</option>
                                                                        <option value="description">شرح</option>
                                                                        <option value="stuffName">کالا</option>
                                                                        <option value="customerName">مشتری / تامین کننده</option>
                                                                        <option value="number">شماره رسید/حواله</option>
                                                                        <option value="amount">ورود (خروج)</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        }
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}